export default "__VITE_ASSET__70a7ee3e__"